import script from "./invitationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./invitationView.vue?vue&type=script&setup=true&lang=ts"

import "./invitationView.vue?vue&type=style&index=0&id=574b203e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574b203e"]])

export default __exports__